import callApi from '../Api/config';

export const getOptions = async (param: any) => {
  try {
    console.log(`Fetching options for entity: ${param}`);

    // Check if param already contains query parameters
    const hasQueryParams = param.includes('?');
    const separator = hasQueryParams ? '&' : '?';
    const response = await callApi(`${param}${separator}page=1&limit=100`, 'GET');

    if (!response?.data?.data?.results) {
      console.error(`No results found for ${param}`, response);
      return [];
    }

    console.log(
      `Successfully fetched ${response?.data?.data?.results.length} options for ${param}`
    );
    return response?.data?.data?.results;
  } catch (error) {
    console.error(`Error fetching options for ${param}:`, error);
    return [];
  }
};
